import { Link } from '@tanstack/react-router';

import { cx } from '@libs/classnames';
import { DateView } from '@ui/components/DateView';

import { ClubLogo } from '@features/club/ui/ClubLogo';
import { components } from '@features/shared/api/public';
import { EventClockControl } from '@features/shared/ui/EventClockControl/EventClockControl';
import { EventMode } from '@features/shared/ui/EventMode';

import styles from './TournamentsList.module.css';

type Props = {
  tournament: components['schemas']['TournamentPublicDto'];
};

export function TournamentsListItem({ tournament }: Props) {
  return (
    <div className={styles.tournamentWrapper}>
      <Link
        to="/club/$clubId/tournament/$tournamentId"
        params={{
          clubId: tournament.clubId,
          tournamentId: tournament.tournamentId,
        }}
      >
        <ClubLogo className={styles.logo} logoUrl={tournament.clubLogoUrl} />
      </Link>

      <div className={styles.tournamentItem}>
        <div className={styles.tournamentName}>
          <Link
            to="/club/$clubId/tournament/$tournamentId"
            params={{
              clubId: tournament.clubId,
              tournamentId: tournament.tournamentId,
            }}
          >
            {tournament.title}
          </Link>
        </div>
        <div className={styles.tournamentOrganizer}>
          <Link to="/club/$clubId" params={{ clubId: tournament.clubId }}>
            {tournament.clubTitle}
          </Link>
        </div>
        <div className={cx(styles.tournamentInfo, styles.wider)}>
          <div className={styles.tournamentClockControl}>
            <EventClockControl tournament={tournament} variant="time-only" />
          </div>
          <div className={styles.tournamentEntrance}>
            <EventMode tournament={tournament} />
          </div>
        </div>
        <div className={styles.tournamentInfo}>
          <div className={styles.tournamentParticipants}>{tournament.participantsCount} чел</div>
          <div className={styles.tournamentDate}>
            <DateView date={tournament.startTimestampMs} showTime />
          </div>
        </div>
      </div>
    </div>
  );
}
